import { Component } from '@theme/component';

import { morph } from '@theme/morph';

import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

import { mediaQueryLarge, getIOSVersion } from '@theme/utilities';

import VariantPicker from '@theme/variant-picker';

import { StandardEvents, ProductSelectEvent, CartLinesUpdateEvent } from '@shopify/events';



    (() => {
      const initializePersonalization = (root) => {
        if (!root || root.dataset.initialized === 'true') return;
  
        const modal = root.querySelector('.dan-personalization__modal');
        const openButton = root.querySelector('.dan-personalization__open');
        const closeButton = root.querySelector('.dan-personalization__modal-close');
        const doneButton = root.querySelector('.dan-personalization__done');
        const noneButton = root.querySelector('.dan-personalization__none-confirm');
        const cartError = root.querySelector('[data-cart-error]');
        const cartErrorDefault = cartError?.textContent.trim() || 'Unable to add these items. Please try again.';
        const multiControl = root.querySelector('[data-multi-control]');
        const walletCount = root.querySelector('[data-wallet-count]');
        const sameAll = root.querySelector('[data-same-all]');
        const editorsContainer = root.querySelector('[data-wallet-editors]');
        const firstEditor = root.querySelector('[data-wallet-editor]');
        const walletNotesSection = root.querySelector('[data-wallet-notes]');
        const walletNotesList = root.querySelector('[data-wallet-notes-list]');
        const walletNoteTemplate = root.querySelector('[data-wallet-note-template]');
        const optionSource = root.querySelector('.dan-personalization__option-source');
        const zoomDialog = root.querySelector('.dan-personalization__zoom-dialog');
        const zoomImage = root.querySelector('.dan-personalization__zoom-image');
        const zoomCaption = root.querySelector('.dan-personalization__zoom-caption');
        const zoomClose = root.querySelector('.dan-personalization__zoom-close');
        const maximumLength = Math.max(1, Number(root.dataset.maxCharacters) || 9);
        const counterLabel = root.dataset.counterLabel || 'characters';
        const walletLabel = root.dataset.walletLabel || 'Wallet';
        const allWalletsLabel = root.dataset.allWalletsLabel || 'All wallets';
        const walletNoteLabel = root.dataset.walletNoteLabel || "Customer's note";
        const walletNotePropertyName = "Customer's note";
        const maximumWalletNoteLength = Math.max(1, Number(root.dataset.walletNoteMax) || 250);
  
        if (!modal || !editorsContainer || !firstEditor) return;
        root.dataset.initialized = 'true';

        const cleanupTasks = [];
        const listen = (target, eventName, handler, options) => {
          if (!target) return;
          target.addEventListener(eventName, handler, options);
          cleanupTasks.push(() => target.removeEventListener(eventName, handler, options));
        };
  
        optionSource?.querySelectorAll('[data-personalization-placement-card]').forEach((card) => {
          firstEditor.querySelector('[data-placement-grid]')?.appendChild(card);
        });
        optionSource?.querySelectorAll('[data-personalization-thread-card]').forEach((card) => {
          firstEditor.querySelector('[data-thread-grid]')?.appendChild(card);
        });
  
        const editorTemplate = firstEditor.cloneNode(true);
        const outputControls = {
          personalization: root.querySelector('[data-output-personalization]'),
          placement: root.querySelector('[data-output-placement]'),
          thread: root.querySelector('[data-output-thread]'),
          logo: root.querySelector('[data-output-logo]')
        };
        const walletStates = new Map();
        const walletNoteStates = new Map();
       const hiddenPaymentButtons = new Map();
const boundNativeAddButtons = new WeakSet();
const transferredThemeNoteFields = new WeakSet();
        const formOwners =
          window.__danPersonalizationFormOwners ||
          (window.__danPersonalizationFormOwners = new WeakMap());
        let productForm = null;
        let ownedForm = null;
        let existingCustomerNote = null;
        let hiddenThemeNoteState = null;
        let previousQuantity = 1;
        let refreshFrame = 0;
        let observer = null;
        let destroyed = false;
        let submittingSeparateItems = false;
  
        const countCharacters = (value) => Array.from(value || '').length;

        const setTextIfChanged = (element, value) => {
          if (!element) return;
          const nextValue = String(value ?? '');
          if (element.textContent !== nextValue) element.textContent = nextValue;
        };
  
        const getSectionScope = () => root.closest('.shopify-section') || root.parentElement || document;
  
        const resolveProductForm = () => {
          const sectionScope = getSectionScope();
          const productContainer = root.closest(
            'product-info, .product-information, .product-info, [data-product-id]'
          );
          const expectedFormId = root.dataset.productFormId || '';
          const localForms = [
            ...(productContainer?.querySelectorAll('form[action*="/cart/add"]') || []),
            ...(sectionScope?.querySelectorAll?.('form[action*="/cart/add"]') || [])
          ];
          const expectedForm =
            localForms.find((form) => form.id === expectedFormId) ||
            document.getElementById(expectedFormId);
          const candidates = [
            expectedForm,
            productContainer?.querySelector('form[action*="/cart/add"]'),
            sectionScope?.querySelector('form[action*="/cart/add"]')
          ];
          const candidate =
            candidates.find(
              (form) => {
                if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="id"]')) {
                  return false;
                }
                const currentOwner = formOwners.get(form);
                return !currentOwner || currentOwner === root || !currentOwner.isConnected;
              }
            ) || null;

          if (candidate) {
            if (ownedForm && ownedForm !== candidate && formOwners.get(ownedForm) === root) {
              formOwners.delete(ownedForm);
            }
            formOwners.set(candidate, root);
            ownedForm = candidate;
          }

          if (candidate && !candidate.id) candidate.id = root.id + '-ProductForm';
          productForm = candidate;

          if (productForm?.id) {
            Object.values(outputControls).forEach((control) => {
              control?.setAttribute('form', productForm.id);
            });
          }

          return productForm;
        };
  
        const getProductScope = () => {
          const form = resolveProductForm();
          return (
            form?.closest('product-info, .product-information, .product-info, [data-product-id], .shopify-section') ||
            getSectionScope()
          );
        };
  
        const getQuantity = () => {
          const form = resolveProductForm();
          const component = form?.closest('product-form-component');
          const quantitySelector =
            component?.refs?.quantitySelector ||
            component?.querySelector('quantity-selector-component');
          const quantityInput =
            component?.querySelector('quantity-selector-component input[ref="quantityInput"]') ||
            form?.querySelector('input[name="quantity"], select[name="quantity"]');
          const quantity =
            Number(quantitySelector?.getValue?.()) ||
            Number(quantityInput?.value) ||
            1;

          return Math.max(1, Math.floor(quantity));
        };
  
        const openDialog = (dialog) => {
          if (!dialog) return;
          try {
            if (typeof dialog.showModal === 'function') {
              if (!dialog.open) dialog.showModal();
            } else {
              dialog.setAttribute('open', '');
            }
          } catch (error) {
            dialog.setAttribute('open', '');
          }
        };
  
        const closeDialog = (dialog) => {
          if (!dialog) return;
          if (typeof dialog.close === 'function' && dialog.open) {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
        };
  
        const remapEditorIds = (editor, index) => {
          const idMap = new Map();
  
          editor.querySelectorAll('[id]').forEach((element) => {
            const originalId = element.id.replace(/-Wallet\d+$/, '');
            const newId = originalId + '-Wallet' + index;
            idMap.set(element.id, newId);
            idMap.set(originalId, newId);
            element.id = newId;
          });
  
          ['for', 'aria-controls', 'aria-labelledby'].forEach((attribute) => {
            editor.querySelectorAll('[' + attribute + ']').forEach((element) => {
              const currentValue = element.getAttribute(attribute);
              if (idMap.has(currentValue)) element.setAttribute(attribute, idMap.get(currentValue));
            });
          });
  
          editor.querySelectorAll('[data-personalization-placement]').forEach((input) => {
            input.name = root.id + '-placement-' + index;
          });
          editor.querySelectorAll('[data-thread-color]').forEach((input) => {
            input.name = root.id + '-thread-' + index;
          });
        };
  
        const cleanNameInput = (editor, showError = false) => {
          const input = editor.querySelector('[data-name-input]');
          const counter = editor.querySelector('[data-character-counter]');
          const error = editor.querySelector('[data-input-error]');
          if (!input) return;
  
          const originalValue = input.value;
          const validCharacters = originalValue.replace(/[^\p{L}\p{M}\p{N} ♥@&:.,\/-]/gu, '');
          input.value = Array.from(validCharacters).slice(0, maximumLength).join('');
  
          if (counter) {
            setTextIfChanged(
              counter,
              countCharacters(input.value) + '/' + maximumLength + ' ' + counterLabel
            );
          }
          if (error) error.hidden = !(showError && originalValue !== input.value);
        };
  
        const syncEditor = (editor) => {
          const active = editor.dataset.active === 'true';
          const nameToggle = editor.querySelector('[data-name-toggle]');
          const namePanel = editor.querySelector('[data-name-panel]');
          const nameInput = editor.querySelector('[data-name-input]');
          const placementFieldset = editor.querySelector('.dan-personalization__placement-fieldset');
          const placementInputs = [...editor.querySelectorAll('[data-personalization-placement]')];
          const threadSection = editor.querySelector('.dan-personalization__thread-section');
          const threadToggle = editor.querySelector('[data-thread-toggle]');
          const threadPanel = editor.querySelector('[data-thread-panel]');
          const threadFieldset = editor.querySelector('.dan-personalization__thread-fieldset');
          const threadInputs = [...editor.querySelectorAll('[data-thread-color]')];
          const logoToggle = editor.querySelector('[data-logo-toggle]');
          const nameEnabled = active && Boolean(nameToggle?.checked);
          const threadEnabled = active && Boolean(threadToggle?.checked);
  
          if (nameToggle) nameToggle.disabled = !active;
          if (threadToggle) threadToggle.disabled = !active || threadInputs.length === 0;
          if (logoToggle) logoToggle.disabled = !active;
  
          if (namePanel) namePanel.hidden = !nameEnabled;
          nameToggle?.setAttribute('aria-expanded', nameEnabled ? 'true' : 'false');
          if (nameInput) {
            nameInput.disabled = !nameEnabled;
            nameInput.required = nameEnabled;
          }
          if (placementFieldset) placementFieldset.hidden = placementInputs.length === 0;
          placementInputs.forEach((input) => {
            input.disabled = !nameEnabled;
            input.required = nameEnabled;
          });
  
          if (threadSection) threadSection.hidden = threadInputs.length === 0;
          if (threadPanel) threadPanel.hidden = !threadEnabled;
          threadToggle?.setAttribute('aria-expanded', threadEnabled ? 'true' : 'false');
          if (threadFieldset) threadFieldset.hidden = threadInputs.length === 0;
          threadInputs.forEach((input) => {
            input.disabled = !threadEnabled;
            input.required = threadEnabled;
          });
  
          cleanNameInput(editor);
        };
  
        const initializeEditor = (editor, index) => {
          if (editor.dataset.editorReady === 'true') return;
          editor.dataset.editorReady = 'true';
          editor.dataset.walletIndex = String(index);
          remapEditorIds(editor, index);
        };

        const readEditorState = (editor) => ({
          nameEnabled: Boolean(editor.querySelector('[data-name-toggle]')?.checked),
          name: editor.querySelector('[data-name-input]')?.value || '',
          placement: editor.querySelector('[data-personalization-placement]:checked')?.value || '',
          threadEnabled: Boolean(editor.querySelector('[data-thread-toggle]')?.checked),
          thread: editor.querySelector('[data-thread-color]:checked')?.value || '',
          noLogo: Boolean(editor.querySelector('[data-logo-toggle]')?.checked)
        });

        const saveEditorState = (editor) => {
          const index = Number(editor.dataset.walletIndex);
          if (Number.isFinite(index) && index > 0) walletStates.set(index, readEditorState(editor));
        };

        const restoreEditorState = (editor, index) => {
          const state = walletStates.get(index);
          if (!state) return;

          const nameToggle = editor.querySelector('[data-name-toggle]');
          const nameInput = editor.querySelector('[data-name-input]');
          const threadToggle = editor.querySelector('[data-thread-toggle]');
          const logoToggle = editor.querySelector('[data-logo-toggle]');
          if (nameToggle) nameToggle.checked = state.nameEnabled;
          if (nameInput) nameInput.value = state.name;
          if (threadToggle) threadToggle.checked = state.threadEnabled;
          if (logoToggle) logoToggle.checked = state.noLogo;

          editor.querySelectorAll('[data-personalization-placement]').forEach((input) => {
            input.checked = Boolean(state.placement) && input.value === state.placement;
          });
          editor.querySelectorAll('[data-thread-color]').forEach((input) => {
            input.checked = Boolean(state.thread) && input.value === state.thread;
          });
        };
  
        initializeEditor(firstEditor, 1);
  
        const ensureEditorCount = (requestedCount) => {
          const targetCount = Math.max(1, Math.floor(Number(requestedCount) || 1));
          let editors = [...editorsContainer.querySelectorAll('[data-wallet-editor]')];

          if (editors.length > targetCount) {
            editors.slice(targetCount).forEach((editor) => {
              saveEditorState(editor);
              editor.remove();
            });
            editors = editors.slice(0, targetCount);
          }

          if (editors.length >= targetCount) return;

          const fragment = document.createDocumentFragment();
          for (let index = editors.length + 1; index <= targetCount; index += 1) {
            const clone = editorTemplate.cloneNode(true);
            initializeEditor(clone, index);
            restoreEditorState(clone, index);
            fragment.appendChild(clone);
          }
          editorsContainer.appendChild(fragment);
        };
  
        const fieldText = (field) => {
          const labels = field.labels ? [...field.labels].map((label) => label.textContent).join(' ') : '';
          return [
            field.name,
            field.id,
            field.className,
            field.placeholder,
            field.getAttribute('aria-label'),
            labels
          ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
        };
  
        const findExistingCustomerNote = () => {
          const scope = getProductScope();
          if (!scope) return null;
  
          return (
            [...scope.querySelectorAll('textarea, input[type="text"]')].find((field) => {
              if (root.contains(field)) return false;
              const text = fieldText(field);
              return (
                /customer['’]?s?[\s_-]*note/.test(text) ||
                /order[\s_-]*note/.test(text) ||
                /special[\s_-]*instructions?/.test(text) ||
                field.name === 'note'
              );
            }) || null
          );
        };

        const restoreThemeNoteField = () => {
          if (!hiddenThemeNoteState) return;
          const { field, fieldHidden, fieldDisabled, labels, wrapper, wrapperHidden } = hiddenThemeNoteState;
          field.hidden = fieldHidden;
          field.disabled = fieldDisabled;
          if (wrapper) wrapper.hidden = wrapperHidden;
          labels.forEach(({ label, hidden }) => {
            label.hidden = hidden;
          });
          hiddenThemeNoteState = null;
        };

        const hideThemeNoteField = () => {
          const field = existingCustomerNote;
          if (!field || hiddenThemeNoteState?.field === field) return;
          restoreThemeNoteField();
          const wrapperCandidate = field.closest(
            '.field, .form-field, .product-form__input, .product-form__field, [data-custom-property], [data-product-property], [data-line-item-property]'
          );
          const wrapper =
            wrapperCandidate && wrapperCandidate.querySelectorAll('textarea, input').length === 1
              ? wrapperCandidate
              : null;
          hiddenThemeNoteState = {
            field,
            fieldHidden: field.hidden,
            fieldDisabled: field.disabled,
            wrapper,
            wrapperHidden: wrapper?.hidden || false,
            labels: [...(field.labels || [])].map((label) => ({ label, hidden: label.hidden }))
          };
          field.hidden = true;
          field.disabled = true;
          if (wrapper) wrapper.hidden = true;
          hiddenThemeNoteState.labels.forEach(({ label }) => {
            label.hidden = true;
          });
        };

        const refreshExistingNote = () => {
          const foundNote = findExistingCustomerNote();
          if (foundNote !== existingCustomerNote) {
            if (hiddenThemeNoteState?.field !== foundNote) restoreThemeNoteField();
            existingCustomerNote = foundNote;
          }
        };

        const updateWalletNoteCounter = (card) => {
          const input = card?.querySelector('[data-wallet-note-input]');
          const counter = card?.querySelector('[data-wallet-note-counter]');
          if (!input || !counter) return;
          const characters = Array.from(input.value || '');
          if (characters.length > maximumWalletNoteLength) {
            input.value = characters.slice(0, maximumWalletNoteLength).join('');
          }
          setTextIfChanged(
            counter,
            Array.from(input.value || '').length + '/' + maximumWalletNoteLength + ' ' + counterLabel
          );
        };

        const readWalletNoteState = (card) =>
          card?.querySelector('[data-wallet-note-input]')?.value || '';

        const saveWalletNoteState = (card) => {
          const index = Number(card?.dataset.walletNoteIndex);
          if (Number.isFinite(index) && index > 0) {
            walletNoteStates.set(index, readWalletNoteState(card));
          }
        };

        const initializeWalletNote = (card, index) => {
          if (!card) return;
          card.dataset.walletNoteIndex = String(index);
          const input = card.querySelector('[data-wallet-note-input]');
          const label = card.querySelector('[data-wallet-note-label]');
          const inputId = root.id + '-WalletNote-' + index;
          if (input) {
            input.id = inputId;
            input.maxLength = maximumWalletNoteLength;
            input.value = walletNoteStates.get(index) || '';
          }
          if (label) {
            label.htmlFor = inputId;
            setTextIfChanged(label, walletNoteLabel + ' — ' + walletLabel + ' ' + index);
          }
          updateWalletNoteCounter(card);
        };

        const getWalletNoteCards = () =>
          [...root.querySelectorAll('[data-wallet-note]')].sort(
            (left, right) => Number(left.dataset.walletNoteIndex) - Number(right.dataset.walletNoteIndex)
          );

        const ensureWalletNoteCount = (requestedCount) => {
          const targetCount = Math.max(0, Math.floor(Number(requestedCount) || 0));
          let cards = getWalletNoteCards();

          if (cards.length > targetCount) {
            cards.slice(targetCount).forEach((card) => {
              saveWalletNoteState(card);
              card.remove();
            });
            cards = cards.slice(0, targetCount);
          }

          if (!walletNoteTemplate || cards.length >= targetCount) return;
          const fragment = document.createDocumentFragment();
          for (let index = cards.length + 1; index <= targetCount; index += 1) {
            const card = walletNoteTemplate.content.firstElementChild?.cloneNode(true);
            initializeWalletNote(card, index);
            if (card) fragment.appendChild(card);
          }
          walletNotesList?.appendChild(fragment);
        };

        const getWalletNote = (index) => {
          const card = getWalletNoteCards().find(
            (item) => Number(item.dataset.walletNoteIndex) === Number(index)
          );
          return (card ? readWalletNoteState(card) : walletNoteStates.get(Number(index)) || '').trim();
        };

        const hasAnyWalletNote = () => {
          const quantity = getQuantity();
          if (quantity <= 1) return false;
          for (let index = 1; index <= quantity; index += 1) {
            if (getWalletNote(index)) return true;
          }
          return false;
        };

        const syncWalletNotes = (quantity, separate) => {
          if (quantity <= 1) {
            getWalletNoteCards().forEach(saveWalletNoteState);
            ensureWalletNoteCount(0);

            const walletOneNote = walletNoteStates.get(1) || '';
            if (previousQuantity > 1 && existingCustomerNote && walletNoteStates.has(1)) {
              existingCustomerNote.value = walletOneNote;
              existingCustomerNote.dispatchEvent(new Event('input', { bubbles: true }));
              existingCustomerNote.dispatchEvent(new Event('change', { bubbles: true }));
            }
            restoreThemeNoteField();
            if (walletNotesSection) walletNotesSection.hidden = true;
            previousQuantity = quantity;
            return;
          }

          ensureWalletNoteCount(quantity);
          const firstNoteInput = getWalletNoteCards()[0]?.querySelector('[data-wallet-note-input]');
          if (
            existingCustomerNote &&
            firstNoteInput &&
            (
              previousQuantity <= 1 ||
              (
                !transferredThemeNoteFields.has(existingCustomerNote) &&
                existingCustomerNote.value?.trim() &&
                !firstNoteInput.value.trim()
              )
            )
          ) {
            firstNoteInput.value = existingCustomerNote.value || '';
            updateWalletNoteCounter(firstNoteInput.closest('[data-wallet-note]'));
            transferredThemeNoteFields.add(existingCustomerNote);
          }
          hideThemeNoteField();

          const cards = getWalletNoteCards();
          if (separate) {
            const editors = [...editorsContainer.querySelectorAll('[data-wallet-editor]')];
            cards.forEach((card, index) => editors[index]?.appendChild(card));
            if (walletNotesSection) walletNotesSection.hidden = true;
          } else {
            cards.forEach((card) => walletNotesList?.appendChild(card));
            if (walletNotesSection) walletNotesSection.hidden = false;
          }
          previousQuantity = quantity;
        };
  
        const getActiveEditors = () => {
          const quantity = getQuantity();
          const editors = [...editorsContainer.querySelectorAll('[data-wallet-editor]')];
          if (quantity === 1 || sameAll?.checked) return editors.slice(0, 1);
          return editors.slice(0, quantity);
        };
  
        const getEditorProperties = (editor) => {
          const properties = {};
          const nameEnabled = Boolean(editor.querySelector('[data-name-toggle]')?.checked);
          const threadEnabled = Boolean(editor.querySelector('[data-thread-toggle]')?.checked);
          const noLogo = Boolean(editor.querySelector('[data-logo-toggle]')?.checked);
          const name = editor.querySelector('[data-name-input]')?.value.trim() || '';
          const placement = editor.querySelector('[data-personalization-placement]:checked')?.value || '';
          const thread = editor.querySelector('[data-thread-color]:checked')?.value || '';
  
          if (nameEnabled && name) {
            properties.Personalization = name;
            if (placement) properties['Personalization placement'] = placement;
          }
          if (threadEnabled && thread) properties['Thread color'] = thread;
          if (nameEnabled || threadEnabled || noLogo) properties['DAN logo'] = noLogo ? 'No' : 'Yes';
          return properties;
        };
  
        const editorHasCustomization = (editor) =>
          Object.keys(getEditorProperties(editor)).length > 0 ||
          Boolean(editor.querySelector('[data-name-toggle]')?.checked) ||
          Boolean(editor.querySelector('[data-thread-toggle]')?.checked) ||
          Boolean(editor.querySelector('[data-logo-toggle]')?.checked);
  
        const setOutput = (control, value) => {
          if (!control) return;
          control.value = value || '';
          control.disabled = !value;
        };
  
        const syncFormOutputs = () => {
          Object.values(outputControls).forEach((control) => {
            if (control) {
              control.value = '';
              control.disabled = true;
            }
          });
  
          const quantity = getQuantity();
          if (quantity > 1 && sameAll && !sameAll.checked) return;
  
          const properties = getEditorProperties(firstEditor);
          setOutput(outputControls.personalization, properties.Personalization);
          setOutput(outputControls.placement, properties['Personalization placement']);
          setOutput(outputControls.thread, properties['Thread color']);
          setOutput(outputControls.logo, properties['DAN logo']);
          resolveProductForm();
        };


        const syncActionButtons = () => {
          const customized =
            getActiveEditors().some(editorHasCustomization) || hasAnyWalletNote();
          if (doneButton) doneButton.hidden = !customized;
          if (noneButton) noneButton.hidden = false;
        };
  
        const refreshEditorLayout = () => {
          refreshExistingNote();
          const quantity = getQuantity();
          const separate = quantity > 1 && sameAll && !sameAll.checked;
          getWalletNoteCards().forEach((card) => walletNotesList?.appendChild(card));
          ensureEditorCount(separate ? quantity : 1);
          const editors = [...editorsContainer.querySelectorAll('[data-wallet-editor]')];
  
          if (multiControl) multiControl.hidden = quantity <= 1;
          setTextIfChanged(walletCount, quantity);
  
          editors.forEach((editor, index) => {
            const active = separate || index === 0;
            const heading = editor.querySelector('[data-wallet-heading]');
            editor.hidden = !active;
            editor.dataset.active = active ? 'true' : 'false';
            editor.classList.toggle('dan-personalization__wallet-editor--separate', separate && active);
  
            if (heading) {
              heading.hidden = quantity <= 1;
              setTextIfChanged(
                heading,
                separate ? walletLabel + ' ' + (index + 1) : allWalletsLabel
              );
            }
            syncEditor(editor);
          });

          syncWalletNotes(quantity, separate);
  
syncActionButtons();
syncFormOutputs();
bindNativeAddButtons();
hideAcceleratedCheckout();
        };
  
        const scheduleRefresh = () => {
          if (destroyed || !root.isConnected) return;
          window.cancelAnimationFrame(refreshFrame);
          refreshFrame = window.requestAnimationFrame(() => {
            if (!destroyed && root.isConnected) refreshEditorLayout();
          });
        };
  
        const hideAcceleratedCheckout = () => {
          const scope = getProductScope();
          scope
            ?.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]')
            .forEach((button) => {
              if (!hiddenPaymentButtons.has(button)) {
                hiddenPaymentButtons.set(button, {
                  hadHiddenAttribute: button.hasAttribute('hidden'),
                  display: button.style.getPropertyValue('display'),
                  displayPriority: button.style.getPropertyPriority('display')
                });
              }
              button.hidden = true;
              button.style.setProperty('display', 'none', 'important');
            });
        };

        const restoreAcceleratedCheckout = () => {
          hiddenPaymentButtons.forEach((state, button) => {
            if (state.hadHiddenAttribute) {
              button.setAttribute('hidden', '');
            } else {
              button.removeAttribute('hidden');
            }

            if (state.display) {
              button.style.setProperty('display', state.display, state.displayPriority);
            } else {
              button.style.removeProperty('display');
            }
          });
          hiddenPaymentButtons.clear();
        };

        const showCartError = (message) => {
          if (!cartError) return;
          setTextIfChanged(cartError, message || cartErrorDefault);
          cartError.hidden = false;
          openDialog(modal);
          cartError.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        };
  
        const clearCartError = () => {
          if (!cartError) return;
          setTextIfChanged(cartError, cartErrorDefault);
          cartError.hidden = true;
        };
  
        const getFirstInvalidControl = () => {
          for (const editor of getActiveEditors()) {
            if (editor.querySelector('[data-name-toggle]')?.checked) {
              const nameInput = editor.querySelector('[data-name-input]');
              const placements = [...editor.querySelectorAll('[data-personalization-placement]')];
              if (!nameInput?.value.trim()) return nameInput;
              if (placements.length && !placements.some((input) => input.checked)) return placements[0];
            }
  
            if (editor.querySelector('[data-thread-toggle]')?.checked) {
              const colors = [...editor.querySelectorAll('[data-thread-color]')];
              if (colors.length && !colors.some((input) => input.checked)) return colors[0];
            }
          }
          return null;
        };
  
        const validateEditors = () => {
          getActiveEditors().forEach((editor) => cleanNameInput(editor));
          const invalidControl = getFirstInvalidControl();
          if (!invalidControl) return true;
  
          openDialog(modal);
          invalidControl.closest('[data-wallet-editor]')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          window.setTimeout(() => {
            invalidControl.focus?.({ preventScroll: true });
            invalidControl.reportValidity?.();
          }, 80);
          return false;
        };
  
        const resetAllPersonalization = () => {
          walletStates.clear();
          editorsContainer.querySelectorAll('[data-wallet-editor]').forEach((editor) => {
            editor.querySelectorAll('[data-name-toggle], [data-thread-toggle], [data-logo-toggle]').forEach((input) => {
              input.checked = false;
            });
            editor.querySelectorAll('[data-name-input]').forEach((input) => {
              input.value = '';
            });
            editor.querySelectorAll('[data-personalization-placement], [data-thread-color]').forEach((input) => {
              input.checked = false;
            });
            editor.querySelectorAll('[data-input-error]').forEach((error) => {
              error.hidden = true;
            });
          });
  
          if (sameAll) sameAll.checked = true;
          clearCartError();
          refreshEditorLayout();
        };
  
        const openPersonalization = () => {
          clearCartError();
          refreshEditorLayout();
          openDialog(modal);
        };
  
        const closePersonalization = () => closeDialog(modal);
  
        const openZoom = (button) => {
          const card = button.closest('.dan-personalization__option-card');
          const optionInput = card?.querySelector('.dan-personalization__option-input');
          if (optionInput && !optionInput.disabled) {
            optionInput.checked = true;
            optionInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (!zoomDialog || !zoomImage) return;
  
          zoomImage.src = button.dataset.zoomSrc || '';
          zoomImage.alt = button.dataset.zoomAlt || '';
          const cardStyles = card ? getComputedStyle(card) : null;
          zoomImage.style.setProperty(
            '--dan-active-image-radius',
            cardStyles?.getPropertyValue('--dan-option-image-radius') || '0px'
          );
          if (zoomCaption) {
            setTextIfChanged(zoomCaption, button.dataset.zoomAlt || '');
            zoomCaption.style.setProperty(
              '--dan-active-caption-color',
              cardStyles?.getPropertyValue('--dan-option-label-color') || 'var(--dan-text-color)'
            );
            zoomCaption.style.setProperty(
              '--dan-active-caption-size',
              cardStyles?.getPropertyValue('--dan-option-label-size') || '14px'
            );
          }
          openDialog(zoomDialog);
        };
  
        const insertSymbol = (button) => {
          const editor = button.closest('[data-wallet-editor]');
          const input = editor?.querySelector('[data-name-input]');
          if (!editor || !input || input.disabled) return;
  
          const symbol = button.dataset.symbol || '';
          const currentLength = countCharacters(input.value);
          if (currentLength >= maximumLength) return;
  
          const start = input.selectionStart ?? input.value.length;
          const end = input.selectionEnd ?? input.value.length;
          input.setRangeText(symbol, start, end, 'end');
          cleanNameInput(editor);
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        };
  
        const ignoredPropertyNames = new Set([
          'Personalization',
          'Personalization placement',
          'Thread color',
          'DAN logo',
          walletNotePropertyName,
          '_Wallet number',
          '_Personalization batch'
        ]);

        const getWalletNoteProperties = (index) => {
          const note =
            getWalletNote(index) ||
            (getQuantity() === 1 ? existingCustomerNote?.value?.trim() || '' : '');
          return note ? { [walletNotePropertyName]: note } : {};
        };
  
        const collectBaseProperties = (formData) => {
          const properties = {};
          const themeNotePropertyName =
            existingCustomerNote?.name?.match(/^properties\[(.+)\]$/)?.[1] || '';
  
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (
              !match ||
              ignoredPropertyNames.has(match[1]) ||
              match[1] === themeNotePropertyName ||
              value === ''
            ) continue;
            if (typeof File !== 'undefined' && value instanceof File) {
              if (value.size > 0) {
                throw new Error('File-upload product options cannot be combined with separate wallet personalization.');
              }
              continue;
            }
            properties[match[1]] = String(value);
          }
          return properties;
        };
  
        const collectCartUpdate = (formData) => {
          const update = {};
          const attributes = {};
  
          for (const [key, value] of formData.entries()) {
            if (typeof value !== 'string' || !value.trim()) continue;
            const match = key.match(/^attributes\[(.+)\]$/);
            if (match) attributes[match[1]] = value.trim();
          }
          if (Object.keys(attributes).length) update.attributes = attributes;
          return update;
        };
  
        const shopRoot = () => window.Shopify?.routes?.root || '/';
  
        const postJSON = async (path, body) => {
          const response = await fetch(shopRoot() + path, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(body)
          });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) {
            throw new Error(result.description || result.message || cartErrorDefault);
          }
          return result;
        };
  
        const setFormBusy = (form, busy) => {
          const externalSelector =
            'button[form="' + form.id + '"], input[type="submit"][form="' + form.id + '"]';
          const controls = [
            ...form.querySelectorAll('button[type="submit"], input[type="submit"]'),
            ...(form.id ? [...document.querySelectorAll(externalSelector)] : [])
          ];
          controls.forEach((control) => {
            if (busy) {
              control.dataset.danWasDisabled = control.disabled ? 'true' : 'false';
              control.disabled = true;
            } else {
              control.disabled = control.dataset.danWasDisabled === 'true';
              delete control.dataset.danWasDisabled;
            }
          });
          form.toggleAttribute('aria-busy', busy);
        };

        const getNativeAddButtons = () => {
          const form = resolveProductForm();
          if (!form) return [];
          const selector = 'button[type="submit"], button[name="add"], input[type="submit"]';
          const externalSelector = form.id
            ? 'button[form="' + form.id + '"], input[type="submit"][form="' + form.id + '"]'
            : '';
          return [...new Set([
            ...form.querySelectorAll(selector),
            ...(externalSelector ? [...document.querySelectorAll(externalSelector)] : [])
          ])].filter(
            (button) =>
              button.name !== 'checkout' &&
              !button.closest('.shopify-payment-button, [data-shopify="payment-button"]')
          );
        };

        const bindNativeAddButtons = () => {
          getNativeAddButtons().forEach((button) => {
            if (boundNativeAddButtons.has(button)) return;
            boundNativeAddButtons.add(button);
            listen(button, 'click', handleNativeAddClick, true);
          });
        };
  
        const addSeparateItems = async (form, batchId) => {
          const formData = new FormData(form);
          const variantId = Number(formData.get('id'));
          const sellingPlan = formData.get('selling_plan');
          const quantity = getQuantity();
          const editors = getActiveEditors();
          const sharedEditor = editors[0] || firstEditor;
  
          if (!Number.isFinite(variantId) || variantId <= 0) {
            throw new Error(cartErrorDefault);
          }
  
          const baseProperties = collectBaseProperties(formData);
          const items = Array.from({ length: quantity }, (_, index) => {
            const editor = sameAll?.checked ? sharedEditor : editors[index] || sharedEditor;
            const properties = {
              ...baseProperties,
              ...getEditorProperties(editor),
              ...getWalletNoteProperties(index + 1),
              '_Personalization batch': batchId
            };

            if (quantity > 1) {
              properties['_Wallet number'] = index + 1 + ' of ' + quantity;
            }

            const item = {
              id: variantId,
              quantity: 1,
              properties
            };
            if (sellingPlan) item.selling_plan = Number(sellingPlan) || sellingPlan;
            return item;
          });
  
          const sectionIds = [
            ...document.querySelectorAll('cart-items-component[data-section-id]')
          ]
            .map((component) => component.dataset.sectionId)
            .filter(Boolean);
          const addPayload = { items };
          if (sectionIds.length) addPayload.sections = [...new Set(sectionIds)].join(',');

          const addResult = await postJSON('cart/add.js', addPayload);
          const cartUpdate = collectCartUpdate(formData);
          if (Object.keys(cartUpdate).length) {
            try {
              await postJSON('cart/update.js', cartUpdate);
            } catch (error) {
              console.warn('Personalized items were added, but the cart note could not be updated.', error);
            }
          }

          return {
            variantId: String(variantId),
            sections: addResult?.sections || {}
          };
        };
  
        const cartContainsBatch = async (batchId, expectedQuantity) => {
          try {
            const response = await fetch(shopRoot() + 'cart.js', {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin'
            });
            if (!response.ok) return false;
            const cart = await response.json();
            const matchingQuantity = (cart.items || [])
              .filter((item) => item.properties?.['_Personalization batch'] === batchId)
              .reduce((total, item) => total + (Number(item.quantity) || 0), 0);
            return matchingQuantity >= expectedQuantity;
          } catch (error) {
            return false;
          }
        };

        const updateCartCountFallback = (itemCount) => {
          const count = Math.max(0, Number(itemCount) || 0);
          document.querySelectorAll('cart-icon').forEach((cartIcon) => {
            cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
            const countElement = cartIcon.querySelector('.cart-bubble__text-count');
            if (countElement) {
              countElement.textContent = count > 99 ? '99+' : count > 0 ? String(count) : '';
            }
          });
        };

        const refreshThemeCartSilently = async () => {
          let cart;

          try {
            const cartItemsComponent = document.querySelector('cart-items-component');
            if (cartItemsComponent) {
              await customElements.whenDefined('cart-items-component');
              if (typeof cartItemsComponent.fetchCartData === 'function') {
                cart = await cartItemsComponent.fetchCartData();
              }
            }

            if (!cart?.items) {
              const response = await fetch(shopRoot() + 'cart.js', {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin'
              });
              if (!response.ok) throw new Error('Unable to refresh cart.');
              cart = await response.json();
            }

            updateCartCountFallback(
              cart.item_count ??
                (cart.items || []).reduce(
                  (total, item) => total + (Number(item.quantity) || 0),
                  0
                )
            );
          } catch (error) {
            console.warn('Items were added, but the cart count could not be refreshed.', error);
          }

          return cart;
        };

        const closeContainingQuickAdd = () => {
          const quickAdd = root.closest('quick-add-dialog');
          if (quickAdd && typeof quickAdd.closeDialog === 'function') quickAdd.closeDialog();
        };
  
        const shouldSubmitSeparateItems = () => {
          return getQuantity() > 1;
        };
  
        const submitSeparateCart = async (form) => {
          if (submittingSeparateItems) return;
          if (!form.checkValidity()) {
            form.reportValidity();
            return;
          }
          if (!validateEditors()) return;

          submittingSeparateItems = true;
          clearCartError();
          setFormBusy(form, true);
          const batchId =
            Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
          const expectedQuantity = getQuantity();

          try {
            await addSeparateItems(form, batchId);
            await refreshThemeCartSilently();
            submittingSeparateItems = false;
            setFormBusy(form, false);
            closeContainingQuickAdd();
          } catch (error) {
            if (await cartContainsBatch(batchId, expectedQuantity)) {
              await refreshThemeCartSilently();
              submittingSeparateItems = false;
              setFormBusy(form, false);
              closeContainingQuickAdd();
              return;
            }
            submittingSeparateItems = false;
            setFormBusy(form, false);
            showCartError(error?.message || cartErrorDefault);
          }
        };

        const submitPersonalizedBuyNow = async (requestedForm) => {
          const form =
            requestedForm instanceof HTMLFormElement ? requestedForm : resolveProductForm();
          if (!form) return { handled: false, redirecting: false };

          refreshEditorLayout();
          syncFormOutputs();

          if (!form.checkValidity()) {
            form.reportValidity();
            return { handled: true, redirecting: false };
          }
          if (!validateEditors() || submittingSeparateItems) {
            return { handled: true, redirecting: false };
          }

          submittingSeparateItems = true;
          clearCartError();
          setFormBusy(form, true);
          const quantity = getQuantity();
          const batchId =
            Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);

          try {
            await addSeparateItems(form, batchId);
          } catch (error) {
            const itemsWereAdded = await cartContainsBatch(batchId, quantity);
            if (!itemsWereAdded) {
              submittingSeparateItems = false;
              setFormBusy(form, false);
              showCartError(error?.message || cartErrorDefault);
              return { handled: true, redirecting: false };
            }
          }

          const checkoutUrl = `${shopRoot().replace(/\/?$/, '/')}checkout`;
          window.location.assign(checkoutUrl);
          return { handled: true, redirecting: true };
        };

        root.__danPersonalizationBuyNow = submitPersonalizedBuyNow;

        const handleNativeAddClick = (event) => {
          const form = resolveProductForm();
          if (!form) return;

          refreshEditorLayout();
          syncFormOutputs();
          if (!shouldSubmitSeparateItems()) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          void submitSeparateCart(form);
        };

        const handleProductSubmit = (event) => {
          const form = resolveProductForm();
          if (!form || event.target !== form) return;

          refreshEditorLayout();
          syncFormOutputs();
          if (getActiveEditors().some(editorHasCustomization) && !validateEditors()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          if (!shouldSubmitSeparateItems()) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          void submitSeparateCart(form);
        };
  
        listen(root, 'input', (event) => {
          const editor = event.target.closest?.('[data-wallet-editor]');
          if (editor && event.target.matches('[data-name-input]')) cleanNameInput(editor, true);
          const noteCard = event.target.closest?.('[data-wallet-note]');
          if (noteCard && event.target.matches('[data-wallet-note-input]')) {
            updateWalletNoteCounter(noteCard);
          }
          syncActionButtons();
          syncFormOutputs();
        });
  
        listen(root, 'change', (event) => {
          if (event.target === sameAll) {
            refreshEditorLayout();
            return;
          }
  
          const editor = event.target.closest?.('[data-wallet-editor]');
          if (editor) syncEditor(editor);
          syncActionButtons();
          syncFormOutputs();
        });
  
        listen(root, 'click', (event) => {
          const symbolButton = event.target.closest?.('[data-symbol]');
          if (symbolButton) {
            event.preventDefault();
            insertSymbol(symbolButton);
            return;
          }
  
          const zoomButton = event.target.closest?.('[data-personalization-zoom]');
          if (zoomButton) {
            event.preventDefault();
            openZoom(zoomButton);
          }
        });
  
        listen(openButton, 'click', openPersonalization);
        listen(closeButton, 'click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          closePersonalization();
        });
        listen(doneButton, 'click', () => {
          if (!validateEditors()) return;
          syncFormOutputs();
          closePersonalization();
        });
        listen(noneButton, 'click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          resetAllPersonalization();
          closePersonalization();
        });
        listen(zoomClose, 'click', () => closeDialog(zoomDialog));
  
        listen(modal, 'click', (event) => {
          const symbolButton = event.target.closest?.('[data-symbol]');
          if (symbolButton) {
            event.preventDefault();
            insertSymbol(symbolButton);
            event.stopPropagation();
            return;
          }

          const zoomButton = event.target.closest?.('[data-personalization-zoom]');
          if (zoomButton) {
            event.preventDefault();
            openZoom(zoomButton);
            event.stopPropagation();
            return;
          }

          event.stopPropagation();
          const bounds = modal.getBoundingClientRect();
          const clickedOutside =
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom;
          if (event.target === modal && clickedOutside) closePersonalization();
        });
        listen(modal, 'cancel', (event) => {
          event.preventDefault();
          event.stopPropagation();
          closePersonalization();
        });
        listen(zoomDialog, 'click', (event) => {
          if (event.target === zoomDialog) closeDialog(zoomDialog);
        });
  
        const sectionScope = getSectionScope();
        ['input', 'change', 'click'].forEach((eventName) => {
          listen(sectionScope, eventName, (event) => {
            if (root.contains(event.target)) return;
            if (
              event.target.matches?.(
                '[name="quantity"], [ref="quantityInput"], [name="id"], [name="selling_plan"]'
              ) ||
              event.target.closest?.(
                'quantity-selector-component, variant-selects, variant-radios'
              )
            ) {
              window.setTimeout(scheduleRefresh, 0);
            }
          });
        });
        ['variant:change', 'variant-change', 'product:variant-change', 'variant:update'].forEach((eventName) => {
          listen(sectionScope, eventName, () => window.setTimeout(scheduleRefresh, 0));
        });
  
        listen(document, 'submit', handleProductSubmit, true);
  
        observer = new MutationObserver((mutations) => {
          const hasRelevantExternalChange = mutations.some((mutation) => !root.contains(mutation.target));
          if (!hasRelevantExternalChange || destroyed) return;

          window.cancelAnimationFrame(refreshFrame);
          refreshFrame = window.requestAnimationFrame(() => {
            if (destroyed || !root.isConnected) return;
            refreshExistingNote();
            refreshEditorLayout();
          });
        });
        observer.observe(getProductScope() || sectionScope, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled']
        });

        root.__danPersonalizationCleanup = () => {
          if (destroyed) return;
          destroyed = true;
          closeDialog(zoomDialog);
          closeDialog(modal);
          observer?.disconnect();
          observer = null;
          window.cancelAnimationFrame(refreshFrame);
          restoreThemeNoteField();
          restoreAcceleratedCheckout();
          if (ownedForm && formOwners.get(ownedForm) === root) formOwners.delete(ownedForm);
          ownedForm = null;
          productForm = null;
          cleanupTasks.splice(0).reverse().forEach((cleanup) => cleanup());
          delete root.__danPersonalizationBuyNow;
          delete root.__danPersonalizationCleanup;
          delete root.dataset.initialized;
        };
  
        resolveProductForm();
        refreshEditorLayout();
      };

      window.__danPersonalizationInitialize = initializePersonalization;
      window.__danPersonalizationInitializeAll = (scope = document) => {
        const roots = [];
        if (scope.matches?.('.dan-personalization')) roots.push(scope);
        scope.querySelectorAll?.('.dan-personalization').forEach((root) => roots.push(root));
        roots.forEach((root) => window.__danPersonalizationInitialize(root));
      };

      // Quick Add must not initialize every personalization block while this
      // module is still loading. The fetched Quick Add content is initialized
      // explicitly by setupDanQuickAddPersonalization() after morph() finishes.
    })();

const danQuickGalleryControllers = new WeakMap();

let danQuickOpenInProgress = false;

let danQuickPersonalizationInstance = 0;

/**
 * Fully closes and removes every listener owned by a Quick Add
 * personalization block before Shopify replaces or rebuilds its content.
 * @param {ParentNode} scope
 */
function cleanupDanQuickAddPersonalization(scope) {
  scope.querySelectorAll?.('.dan-personalization').forEach((root) => {
    root.__danQuickSafetyCleanup?.();
    root.__danPersonalizationCleanup?.();
    root.querySelectorAll('dialog[open]').forEach((dialog) => {
      try {
        dialog.close();
      } catch (_error) {
        dialog.removeAttribute('open');
      }
    });
    delete root.dataset.initialized;
    delete root.dataset.danQuickReady;
  });
}

/**
 * Provides a small safety controller around the nested personalization dialog.
 * The main product-page controller still owns personalization data. This layer
 * only guarantees that a failed or interrupted initialization can never leave
 * an invisible modal in the top layer and freeze the page.
 * @param {Element} root
 */
function installDanQuickPersonalizationSafety(root) {
  root.__danQuickSafetyCleanup?.();

  const controller = new AbortController();
  const { signal } = controller;
  const modal = root.querySelector('.dan-personalization__modal');
  const openButton = root.querySelector('.dan-personalization__open');

  if (!(modal instanceof HTMLDialogElement) || !(openButton instanceof HTMLButtonElement)) return;

  const openModal = () => {
    try {
      if (!modal.open) modal.showModal();
    } catch (_error) {
      modal.setAttribute('open', '');
    }
  };

  const closeModal = () => {
    try {
      if (modal.open) modal.close();
    } catch (_error) {
      modal.removeAttribute('open');
    }
  };

  const resetFallback = () => {
    root
      .querySelectorAll('[data-name-toggle], [data-thread-toggle], [data-logo-toggle]')
      .forEach((input) => {
        input.checked = false;
      });
    root.querySelectorAll('[data-name-input]').forEach((input) => {
      input.value = '';
    });
    root
      .querySelectorAll('[data-personalization-placement], [data-thread-color]')
      .forEach((input) => {
        input.checked = false;
      });
    root.querySelectorAll('[data-name-panel], [data-thread-panel]').forEach((panel) => {
      panel.hidden = true;
    });
    root.querySelectorAll('[data-output-personalization], [data-output-placement], [data-output-thread], [data-output-logo]').forEach((output) => {
      output.value = '';
      output.disabled = true;
    });
  };

  openButton.addEventListener(
    'click',
    (event) => {
      if (root.dataset.danQuickReady === 'true') return;
      event.preventDefault();
      openModal();
    },
    { signal }
  );

  modal.addEventListener(
    'click',
    (event) => {
      // Symbol and option-image controls are handled by the main
      // personalization controller through delegation on the root. Allow
      // those clicks to bubble; otherwise the character is never inserted.
      const delegatedControl = event.target.closest?.(
        '[data-symbol], [data-personalization-zoom]'
      );
      if (delegatedControl) return;

      event.stopPropagation();

      const closeButton = event.target.closest?.('.dan-personalization__modal-close');
      const noneButton = event.target.closest?.('.dan-personalization__none-confirm');

      if (closeButton) {
        event.preventDefault();
        closeModal();
        return;
      }

      if (noneButton) {
        event.preventDefault();
        if (root.dataset.danQuickReady !== 'true') resetFallback();
        closeModal();
        return;
      }

      if (event.target === modal) {
        const bounds = modal.getBoundingClientRect();
        const outside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;
        if (outside) closeModal();
      }
    },
    { signal }
  );

  modal.addEventListener(
    'cancel',
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeModal();
    },
    { signal }
  );

  root.addEventListener(
    'change',
    (event) => {
      if (root.dataset.danQuickReady === 'true') return;
      const editor = event.target.closest?.('[data-wallet-editor]');
      if (!editor) return;

      if (event.target.matches('[data-name-toggle]')) {
        const panel = editor.querySelector('[data-name-panel]');
        if (panel) panel.hidden = !event.target.checked;
      }

      if (event.target.matches('[data-thread-toggle]')) {
        const panel = editor.querySelector('[data-thread-panel]');
        if (panel) panel.hidden = !event.target.checked;
      }
    },
    { signal }
  );

  root.__danQuickSafetyCleanup = () => {
    closeModal();
    controller.abort();
    delete root.__danQuickSafetyCleanup;
  };
}

/**
 * Makes duplicate product-form and control IDs unique inside Quick Add.
 * @param {Element} root
 * @param {ParentNode} scope
 */
function prepareDanQuickAddPersonalization(root, scope) {
  const productContainer = root.closest(
    'product-info, .product-information, .product-info, [data-product-id]'
  );
  const form =
    productContainer?.querySelector('form[action*="/cart/add"]') ||
    scope.querySelector?.('form[action*="/cart/add"]');

  if (!(form instanceof HTMLFormElement)) return;
  if (root.dataset.danQuickForm === form.id && form.dataset.danQuickPersonalizationForm) return;

  danQuickPersonalizationInstance += 1;
  const suffix = `-QuickAdd-${danQuickPersonalizationInstance}`;
  const originalFormId = form.id || 'DanQuickAddProductForm';
  const quickFormId = `${originalFormId.replace(/-QuickAdd-\d+$/, '')}${suffix}`;

  form.id = quickFormId;
  form.dataset.danQuickPersonalizationForm = 'true';
  if (root.id) root.id = `${root.id.replace(/-QuickAdd-\d+$/, '')}${suffix}`;
  root.dataset.productFormId = quickFormId;
  root.dataset.danQuickForm = quickFormId;

  productContainer?.querySelectorAll('[form]').forEach((control) => {
    if (control.getAttribute('form') === originalFormId) control.setAttribute('form', quickFormId);
  });

  const idMap = new Map();
  root.querySelectorAll('[id]').forEach((element) => {
    const oldId = element.id;
    if (!oldId) return;
    const newId = `${oldId.replace(/-QuickAdd-\d+$/, '')}${suffix}`;
    idMap.set(oldId, newId);
    element.id = newId;
  });

  ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach((attribute) => {
    root.querySelectorAll(`[${attribute}]`).forEach((element) => {
      const value = element.getAttribute(attribute);
      if (!value) return;
      element.setAttribute(
        attribute,
        value
          .split(/\s+/)
          .map((token) => idMap.get(token) || token)
          .join(' ')
      );
    });
  });

  root.querySelectorAll('[form]').forEach((control) => control.setAttribute('form', quickFormId));
}

/**
 * Initializes the same personalization controller used on the product page.
 * It is run synchronously so the customer cannot click an uninitialized modal.
 * @param {ParentNode} scope
 */
function setupDanQuickAddPersonalization(scope) {
  const roots = [];
  if (scope.matches?.('.dan-personalization')) roots.push(scope);
  scope.querySelectorAll?.('.dan-personalization').forEach((root) => roots.push(root));

  roots.forEach((root) => {
    try {
      root.__danQuickSafetyCleanup?.();
      root.__danPersonalizationCleanup?.();
      delete root.dataset.initialized;
      delete root.dataset.danQuickReady;
      prepareDanQuickAddPersonalization(root, scope);
      installDanQuickPersonalizationSafety(root);
      window.__danPersonalizationInitialize?.(root);
      if (
        root.dataset.initialized === 'true' &&
        typeof root.__danPersonalizationCleanup === 'function'
      ) {
        root.dataset.danQuickReady = 'true';
      }
    } catch (error) {
      delete root.dataset.initialized;
      delete root.dataset.danQuickReady;
      console.error('[quick-add] Personalization initialization failed:', error);
    }
  });
}

/** @param {ParentNode} scope */
function scheduleDanQuickAddPersonalization(scope) {
  setupDanQuickAddPersonalization(scope);
}
/**
 * Turns product media inside Quick Add into a one-item carousel with chevrons,

 * pagination dots and a product-page link. Everything is scoped to the dialog.

 * @param {Element} root

 * @param {string} [fallbackProductUrl]

 */

function setupDanQuickAddGallery(root, fallbackProductUrl = '') {

  const mediaColumn = root.querySelector('.product-information__media');

  const gallery = mediaColumn?.querySelector('media-gallery');

  const container = gallery?.querySelector('slideshow-container');

  const scroller = gallery?.querySelector('slideshow-slides');



  if (

    !(mediaColumn instanceof HTMLElement) ||

    !(gallery instanceof HTMLElement) ||

    !(container instanceof HTMLElement) ||

    !(scroller instanceof HTMLElement)

  ) {

    return;

  }



  danQuickGalleryControllers.get(gallery)?.abort();

  const controller = new AbortController();

  danQuickGalleryControllers.set(gallery, controller);



  container.querySelectorAll('[data-dan-quick-gallery-arrow]').forEach((element) => element.remove());

  mediaColumn.querySelector(':scope > .dan-quick-gallery__footer')?.remove();



  const getSlides = () =>

    Array.from(scroller.querySelectorAll(':scope > slideshow-slide')).filter(

      (slide) => slide instanceof HTMLElement && !slide.hidden

    );



  const slides = getSlides();

  if (slides.length === 0) return;



  const getCurrentIndex = () => {

    const currentSlides = getSlides();

    if (currentSlides.length === 0) return 0;



    let closestIndex = 0;

    let closestDistance = Number.POSITIVE_INFINITY;



    currentSlides.forEach((slide, index) => {

      const distance = Math.abs(slide.offsetLeft - Math.abs(scroller.scrollLeft));



      if (distance < closestDistance) {

        closestDistance = distance;

        closestIndex = index;

      }

    });



    return closestIndex;

  };



  const moveTo = (index, behavior = 'smooth') => {

    const currentSlides = getSlides();

    if (currentSlides.length === 0) return;



    const safeIndex = (index + currentSlides.length) % currentSlides.length;



    scroller.scrollTo({

      left: currentSlides[safeIndex].offsetLeft,

      behavior,

    });



    updateActiveDot(safeIndex);

  };



  const footer = document.createElement('div');

  footer.className = 'dan-quick-gallery__footer';



  const dots = document.createElement('div');

  dots.className = 'dan-quick-gallery__dots';

  dots.setAttribute('role', 'group');

  dots.setAttribute('aria-label', 'Product media');



  const updateActiveDot = (activeIndex = getCurrentIndex()) => {

    dots.querySelectorAll('[data-dan-quick-gallery-dot]').forEach((dot, index) => {

      const isActive = index === activeIndex;



      if (isActive) {

        dot.setAttribute('aria-current', 'true');

      } else {

        dot.removeAttribute('aria-current');

      }



      dot.setAttribute(

        'aria-label',

        `${isActive ? 'Current media' : 'View media'} ${index + 1}`

      );

    });

  };



  slides.forEach((slide, index) => {

    const dot = document.createElement('button');



    dot.type = 'button';

    dot.className = 'dan-quick-gallery__dot';

    dot.setAttribute('data-dan-quick-gallery-dot', String(index));



    dot.addEventListener(

      'click',

      (event) => {

        event.preventDefault();

        moveTo(index);

      },

      { signal: controller.signal }

    );



    dots.appendChild(dot);

  });



  const titleLink = root.querySelector(

    '[ref="productTitleLink"], .view-product-title a'

  );



  const productUrl =

    titleLink instanceof HTMLAnchorElement

      ? titleLink.href

      : fallbackProductUrl;



  const viewProduct = document.createElement('a');



  viewProduct.className =

    'button button-secondary dan-quick-gallery__view-product';



  viewProduct.textContent = 'VIEW PRODUCT';

  viewProduct.href = productUrl || fallbackProductUrl || '#';



  footer.append(dots, viewProduct);

  gallery.insertAdjacentElement('afterend', footer);



  if (slides.length > 1) {

    const createArrow = (direction, label, symbol) => {

      const button = document.createElement('button');



      button.type = 'button';

      button.className =

        `dan-quick-gallery__arrow dan-quick-gallery__arrow--${direction}`;



      button.setAttribute(

        'data-dan-quick-gallery-arrow',

        direction

      );



      button.setAttribute('aria-label', label);

      button.innerHTML = `<span aria-hidden="true">${symbol}</span>`;



      return button;

    };



    const previousButton = createArrow(

      'previous',

      'Previous media',

      '&#8249;'

    );



    const nextButton = createArrow(

      'next',

      'Next media',

      '&#8250;'

    );



    previousButton.addEventListener(

      'click',

      (event) => {

        event.preventDefault();

        event.stopPropagation();

        moveTo(getCurrentIndex() - 1);

      },

      { signal: controller.signal }

    );



    nextButton.addEventListener(

      'click',

      (event) => {

        event.preventDefault();

        event.stopPropagation();

        moveTo(getCurrentIndex() + 1);

      },

      { signal: controller.signal }

    );



    container.append(previousButton, nextButton);

  }



  let scrollFrame = 0;



  scroller.addEventListener(

    'scroll',

    () => {

      cancelAnimationFrame(scrollFrame);



      scrollFrame = requestAnimationFrame(() => {

        updateActiveDot();

      });

    },

    {

      passive: true,

      signal: controller.signal,

    }

  );



  controller.signal.addEventListener(

    'abort',

    () => cancelAnimationFrame(scrollFrame),

    { once: true }

  );



  updateActiveDot(0);

}



export class QuickAddComponent extends Component {

  /** @type {AbortController | null} */

  #abortController = null;



  /** @type {Map<string, Element>} */

  #cachedContent = new Map();



  /** @type {AbortController} */

  #cartUpdateAbortController = new AbortController();



  get productPageUrl() {

    const productCard =

      /** @type {import('./product-card').ProductCard | null} */ (

        this.closest('product-card')

      );



    if (productCard) return productCard.productPageUrl;



    const hotspotProduct =

      /** @type {import('./product-hotspot').ProductHotspotComponent | null} */ (

        this.closest('product-hotspot-component')

      );



    const productLink = hotspotProduct?.getHotspotProductLink();



    return productLink?.href || '';

  }



  /**

   * Gets the currently selected variant ID from the product card.

   * @returns {string | null}

   */

  #getSelectedVariantId() {

    const productCard =

      /** @type {import('./product-card').ProductCard | null} */ (

        this.closest('product-card')

      );



    return productCard?.getSelectedVariantId() ?? null;

  }



  connectedCallback() {

    super.connectedCallback();



    mediaQueryLarge.addEventListener(

      'change',

      this.#closeQuickAddModal

    );



    document.addEventListener(

      StandardEvents.cartLinesUpdate,

      this.#handleCartUpdate,

      {

        signal: this.#cartUpdateAbortController.signal,

      }

    );



    document.addEventListener(

      StandardEvents.productSelect,

      this.#handleProductSelectUpdate

    );

  }



  disconnectedCallback() {

    super.disconnectedCallback();



    mediaQueryLarge.removeEventListener(

      'change',

      this.#closeQuickAddModal

    );



    this.#abortController?.abort();

    this.#cartUpdateAbortController.abort();



    document.removeEventListener(

      StandardEvents.productSelect,

      this.#handleProductSelectUpdate

    );

  }



  /**

   * Updates quick-add button state when a product variant is selected.

   * @param {ProductSelectEvent} event

   */

  #handleProductSelectUpdate = (event) => {

    if (!(event.target instanceof HTMLElement)) return;



    if (

      event.target.closest('product-card') !==

      this.closest('product-card')

    ) {

      return;

    }



    if (this.dataset.usesSellingPlans === 'true') return;



    if (this.dataset.rendersBothButtons !== 'true') return;



    const productOptionsCount =

      this.dataset.productOptionsCount;



    let quickAddButton =

      productOptionsCount === '1' ? 'add' : 'choose';



    if (

      quickAddButton === 'add' &&

      this.#isSelectedVariantUnavailable()

    ) {

      quickAddButton = 'choose';

    }



    this.setAttribute(

      'data-quick-add-button',

      quickAddButton

    );

  };



  /**

   * Checks whether the selected product-card variant is unavailable.

   * @returns {boolean}

   */

  #isSelectedVariantUnavailable() {

    const productCard =

      /** @type {import('./product-card').ProductCard | null} */ (

        this.closest('product-card')

      );



    return (

      productCard?.variantPicker?.selectedOption

        ?.dataset.optionAvailable === 'false'

    );

  }



  /**

   * Clears cached product content after the cart changes.

   */

  #handleCartUpdate = () => {

    this.#cachedContent.clear();

  };



  /**

   * Updates the variant picker in the Quick Add modal.

   * @param {Element} newHtml

   */

  #updateVariantPicker(newHtml) {

    const modalContent = document.getElementById(

      'quick-add-modal-content'

    );



    if (!modalContent) return;



    const variantPicker =

      /** @type {VariantPicker | null} */ (

        modalContent.querySelector('variant-picker')

      );



    if (!variantPicker) return;



    variantPicker.updateVariantPicker(newHtml);

  }



  /**

   * Handles the Quick Add button.

   * @param {Event} event

   */

  handleClick = async (event) => {

    event.preventDefault();

    event.stopPropagation();



    const currentUrl = this.productPageUrl;



    if (this.dataset.usesSellingPlans === 'true') {

      if (currentUrl) {

        window.location.href = currentUrl;

      }



      return;

    }

    if (danQuickOpenInProgress) return;

    danQuickOpenInProgress = true;
    this.setAttribute('aria-busy', 'true');
    const triggerButton = event.target.closest?.('button');
    const triggerWasDisabled = triggerButton instanceof HTMLButtonElement ? triggerButton.disabled : false;
    if (triggerButton instanceof HTMLButtonElement) triggerButton.disabled = true;

    try {



    let productGrid =

      this.#cachedContent.get(currentUrl);



    if (!productGrid) {

      const html = await this.fetchProductPage(currentUrl);



      if (html) {

        const gridElement =

          html.querySelector('[data-product-grid-content]');



        if (gridElement) {

          productGrid =

            /** @type {Element} */ (

              gridElement.cloneNode(true)

            );



          this.#cachedContent.set(

            currentUrl,

            productGrid

          );

        }

      }

    }



    if (!productGrid) return;

    if (productGrid) {

      const freshContent =

        /** @type {Element} */ (

          productGrid.cloneNode(true)

        );



      await this.updateQuickAddModal(freshContent);

      this.#updateVariantPicker(productGrid);

    }



      this.#openQuickAddModal();
    } finally {
      danQuickOpenInProgress = false;
      this.removeAttribute('aria-busy');
      if (triggerButton instanceof HTMLButtonElement) triggerButton.disabled = triggerWasDisabled;
    }

  };



  #resetScroll() {

    const dialogComponent =

      document.getElementById('quick-add-dialog');



    if (!(dialogComponent instanceof QuickAddDialog)) {

      return;

    }



    const productDetails =

      dialogComponent.querySelector('.product-details');



    const productMedia =

      dialogComponent.querySelector(

        '.product-information__media'

      );



    productDetails?.scrollTo({

      top: 0,

      behavior: 'instant',

    });



    productMedia?.scrollTo({

      top: 0,

      behavior: 'instant',

    });

  }



  /**

   * @param {QuickAddDialog} dialogComponent

   */

  #stayVisibleUntilDialogCloses(dialogComponent) {

    this.toggleAttribute('stay-visible', true);



    dialogComponent.addEventListener(

      DialogCloseEvent.eventName,

      () => {

        this.toggleAttribute('stay-visible', false);

      },

      { once: true }

    );

  }



  #openQuickAddModal = () => {

    const dialogComponent =

      document.getElementById('quick-add-dialog');



    if (!(dialogComponent instanceof QuickAddDialog)) {

      return;

    }



    this.#stayVisibleUntilDialogCloses(

      dialogComponent

    );



    dialogComponent.showDialog();



    const dialog = dialogComponent.refs?.dialog;



    if (!dialog) return;



    dialog.addEventListener(

      'animationstart',

      this.#resetScroll.bind(this),

      { once: true }

    );

  };



  #closeQuickAddModal = () => {

    const dialogComponent =

      document.getElementById('quick-add-dialog');



    if (!(dialogComponent instanceof QuickAddDialog)) {

      return;

    }



    dialogComponent.closeDialog();

  };



  /**

   * Fetches the product page content.

   * @param {string} productPageUrl

   * @returns {Promise<Document | null>}

   */

  async fetchProductPage(productPageUrl) {

    if (!productPageUrl) return null;



    this.#abortController?.abort();

    this.#abortController = new AbortController();



    try {

      const response = await fetch(productPageUrl, {

        signal: this.#abortController.signal,

      });



      if (!response.ok) {

        throw new Error(

          `Failed to fetch product page: HTTP error ${response.status}`

        );

      }



      const responseText = await response.text();



      const html = new DOMParser().parseFromString(

        responseText,

        'text/html'

      );



      return html;

    } catch (error) {

      if (error.name === 'AbortError') {

        return null;

      }



      throw error;

    } finally {

      this.#abortController = null;

    }

  }



  /**

   * Re-renders the Quick Add modal.

   * @param {Element} productGrid

   */

  async updateQuickAddModal(productGrid) {

    const modalContent = document.getElementById(

      'quick-add-modal-content'

    );



    if (!productGrid || !modalContent) return;



    const payload =

      productGrid.getAttribute('view-event-payload') || '';



    modalContent.setAttribute(

      'view-event-payload',

      payload

    );



    cleanupDanQuickAddPersonalization(modalContent);

    morph(modalContent, productGrid);



    this.#syncVariantSelection(modalContent);



    try {
      setupDanQuickAddGallery(
        modalContent,
        this.productPageUrl
      );
    } catch (error) {
      console.error('[quick-add] Gallery initialization failed:', error);
    }

    // Never let personalization prevent the Quick Add dialog from opening.
    try {
      scheduleDanQuickAddPersonalization(modalContent);
    } catch (error) {
      console.error('[quick-add] Personalization setup failed:', error);
    }

  }



  /**

   * Synchronizes the selected product-card variant with the modal.

   * @param {Element} modalContent

   */

  #syncVariantSelection(modalContent) {

    const selectedVariantId =

      this.#getSelectedVariantId();



    if (!selectedVariantId) return;



    const modalInputs =

      modalContent.querySelectorAll(

        'input[type="radio"][data-variant-id]'

      );



    for (const input of modalInputs) {

      if (

        input instanceof HTMLInputElement &&

        input.dataset.variantId === selectedVariantId &&

        !input.checked

      ) {

        input.checked = true;



        input.dispatchEvent(

          new Event('change', {

            bubbles: true,

          })

        );



        break;

      }

    }

  }

}



if (!customElements.get('quick-add-component')) {

  customElements.define(

    'quick-add-component',

    QuickAddComponent

  );

}



class QuickAddDialog extends DialogComponent {

  #abortController = new AbortController();



  /** @type {Promise<boolean>} */

  #pendingVariantUpdate = Promise.resolve(true);



  connectedCallback() {

    super.connectedCallback();



    this.addEventListener(

      StandardEvents.cartLinesUpdate,

      this.handleCartUpdate,

      {

        signal: this.#abortController.signal,

      }

    );



    this.addEventListener(

      StandardEvents.productSelect,

      this.#handleProductSelect

    );



    this.addEventListener(

      'click',

      this.#handleDanBuyNow,

      {

        signal: this.#abortController.signal,

      }

    );

    // Capture the personalization trigger at the stable Quick Add wrapper.
    // Shopify may replace the button while synchronizing variants, so a
    // listener attached only to the button itself is not reliable.
    this.addEventListener(
      'click',
      this.#handleDanPersonalizationOpen,
      {
        capture: true,
        signal: this.#abortController.signal,
      }
    );



    this.addEventListener(

      DialogCloseEvent.eventName,

      this.#handleDialogClose

    );

  }



  disconnectedCallback() {

    super.disconnectedCallback();



    this.#abortController.abort();

    cleanupDanQuickAddPersonalization(this);



    this.removeEventListener(

      DialogCloseEvent.eventName,

      this.#handleDialogClose

    );

  }



  /**

   * Closes Quick Add after a successful Add to Cart.

   * @param {CartLinesUpdateEvent} event

   */

  handleCartUpdate = (event) => {

    event.promise

      ?.then(({ detail }) => {

        if (detail?.didError) return;



        this.closeDialog();

      })

      .catch((error) => {

        if (error?.name !== 'AbortError') {

          console.warn(

            '[quick-add] Event promise rejected:',

            error

          );

        }

      });

  };

  /**
   * Opens personalization reliably even after Quick Add content is morphed.
   * @param {Event} event
   */
  #handleDanPersonalizationOpen = (event) => {
    if (!(event.target instanceof Element)) return;

    const openButton = event.target.closest('.dan-personalization__open');
    if (!(openButton instanceof HTMLButtonElement) || !this.contains(openButton)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const root = openButton.closest('.dan-personalization');
    if (!(root instanceof HTMLElement)) return;

    if (root.dataset.danQuickReady !== 'true') {
      setupDanQuickAddPersonalization(root);
    }

    const modal = root.querySelector('.dan-personalization__modal');
    if (!(modal instanceof HTMLDialogElement)) return;

    try {
      if (!modal.open) modal.showModal();
    } catch (_error) {
      modal.setAttribute('open', '');
    }
  };



  /**

   * Adds the selected variant and personalization properties,

   * then redirects directly to checkout.

   * @param {Event} event

   */

  #handleDanBuyNow = async (event) => {

    if (!(event.target instanceof Element)) return;



    const clickedButton = event.target.closest(

      '[data-dan-quick-buy-now]'

    );



    if (

      !(clickedButton instanceof HTMLButtonElement) ||

      clickedButton.disabled

    ) {

      return;

    }



    event.preventDefault();

    event.stopPropagation();



    const setProcessingState = (

      button,

      isProcessing

    ) => {

      if (!(button instanceof HTMLButtonElement)) {

        return;

      }



      const label = button.querySelector(

        '[data-dan-buy-now-label]'

      );



      button.disabled = isProcessing;



      if (isProcessing) {

        button.setAttribute('aria-busy', 'true');

        button.setAttribute(

          'data-processing',

          'true'

        );

      } else {

        button.removeAttribute('aria-busy');

        button.removeAttribute('data-processing');

      }



      if (label) {

        label.textContent = isProcessing

          ? 'PROCESSING…'

          : 'BUY IT NOW';

      }

    };



    setProcessingState(clickedButton, true);



    try {

      const variantIsReady =

        await this.#pendingVariantUpdate;



      if (!variantIsReady) {

        throw new Error(

          'Please select the product option again.'

        );

      }



      const button = this.querySelector(

        '[data-dan-quick-buy-now]'

      );



      if (!(button instanceof HTMLButtonElement)) {

        throw new Error(

          'Buy It Now is temporarily unavailable.'

        );

      }



      setProcessingState(button, true);



      const form = button.closest('form');



      if (!(form instanceof HTMLFormElement)) {

        throw new Error(

          'Product form could not be found.'

        );

      }



      if (!form.reportValidity()) {

        setProcessingState(button, false);

        return;

      }

      const personalizationRoot = this.querySelector('.dan-personalization');
      const personalizedBuyNow = personalizationRoot?.__danPersonalizationBuyNow;

      if (typeof personalizedBuyNow === 'function') {
        const outcome = await personalizedBuyNow(form);

        if (outcome?.handled) {
          if (!outcome.redirecting) setProcessingState(button, false);
          return;
        }
      }



      const formData = new FormData(form);

      const variantId = formData.get('id');



      if (

        typeof variantId !== 'string' ||

        !variantId

      ) {

        throw new Error(

          'Please select an available variant.'

        );

      }



      formData.delete('sections');

      formData.delete('sections_url');



      const response = await fetch(

        Theme.routes.cart_add_url,

        {

          method: 'POST',

          headers: {

            Accept: 'application/json',

            'X-Requested-With': 'XMLHttpRequest',

          },

          body: formData,

          credentials: 'same-origin',

        }

      );



      const responseText = await response.text();

      let result = {};



      try {

        result = responseText

          ? JSON.parse(responseText)

          : {};

      } catch {

        /* Shopify may return HTML for an error. */

      }



      if (!response.ok || result.status) {

        throw new Error(

          result.description ||

            result.message ||

            `Unable to continue to checkout (${response.status}).`

        );

      }



      const shopRoot =

        window.Shopify?.routes?.root || '/';



      window.location.assign(

        `${shopRoot.replace(/\/?$/, '/')}checkout`

      );

    } catch (error) {

      const message =

        error instanceof Error

          ? error.message

          : 'Unable to continue to checkout.';



      const liveRegion =

        this.querySelector('[ref="liveRegion"]');



      if (liveRegion) {

        liveRegion.textContent = message;

      }



      console.error(

        '[quick-add] Buy it now failed:',

        error

      );



      setProcessingState(

        clickedButton,

        false

      );



      setProcessingState(

        this.querySelector(

          '[data-dan-quick-buy-now]'

        ),

        false

      );

    }

  };



  /**

   * Keeps Quick Add synchronized after selecting a variant.

   * @param {ProductSelectEvent} event

   */

  #handleProductSelect = (event) => {

    const buyNowButton = this.querySelector(

      '[data-dan-quick-buy-now]'

    );



    if (buyNowButton instanceof HTMLButtonElement) {

      buyNowButton.disabled = true;

    }



    const pendingUpdate = event.promise

      .then(({ detail }) => {

        if (

          this.#pendingVariantUpdate !== pendingUpdate

        ) {

          return false;

        }



        if (!detail?.html) return false;



        const { html } = detail;



        const anchorElement =

          /** @type {HTMLAnchorElement | null} */ (

            html.querySelector('.view-product-title a')

          );



        const viewMoreDetailsLink =

          /** @type {HTMLAnchorElement | null} */ (

            this.querySelector('.view-product-title a')

          );



        const mobileProductTitle =

          /** @type {HTMLAnchorElement | null} */ (

            this.querySelector('.product-header a')

          );



        const productUrl =

          anchorElement?.href ||

          viewMoreDetailsLink?.href ||

          mobileProductTitle?.href ||

          '';



        if (

          anchorElement &&

          viewMoreDetailsLink

        ) {

          viewMoreDetailsLink.href =

            anchorElement.href;

        }



        if (

          anchorElement &&

          mobileProductTitle

        ) {

          mobileProductTitle.href =

            anchorElement.href;

        }



        requestAnimationFrame(() => {

          setupDanQuickAddGallery(

            this,

            productUrl

          );

          scheduleDanQuickAddPersonalization(this);

        });



        return true;

      })

      .catch((error) => {

        if (error?.name !== 'AbortError') {

          console.warn(

            '[quick-add] Event promise rejected:',

            error

          );

        }



        return false;

      });



    this.#pendingVariantUpdate = pendingUpdate;



    pendingUpdate.then((variantIsReady) => {

      if (

        this.#pendingVariantUpdate !== pendingUpdate

      ) {

        return;

      }



      const currentBuyNowButton =

        this.querySelector(

          '[data-dan-quick-buy-now]'

        );



      const addToCartButton =

        this.querySelector(

          '.add-to-cart-button'

        );



      if (

        currentBuyNowButton instanceof

        HTMLButtonElement

      ) {

        currentBuyNowButton.disabled =

          !variantIsReady ||

          (

            addToCartButton instanceof

              HTMLButtonElement &&

            addToCartButton.disabled

          );

      }

    });

  };



  #handleDialogClose = () => {

    cleanupDanQuickAddPersonalization(this);

    const iosVersion = getIOSVersion();



    if (

      !iosVersion ||

      iosVersion.major >= 17 ||

      (

        iosVersion.major === 16 &&

        iosVersion.minor >= 4

      )

    ) {

      return;

    }



    requestAnimationFrame(() => {

      const grid =

        /** @type {HTMLElement | null} */ (

          document.querySelector(

            '#ResultsList [product-grid-view]'

          )

        );



      if (grid) {

        const currentWidth =

          grid.getBoundingClientRect().width;



        grid.style.width =

          `${currentWidth - 1}px`;



        requestAnimationFrame(() => {

          grid.style.width = '';

        });

      }

    });

  };

}



if (!customElements.get('quick-add-dialog')) {

  customElements.define(

    'quick-add-dialog',

    QuickAddDialog

  );

}

/*

 * Close Quick Add on mobile when the customer

 * swipes downward on the area outside the dialog.

 */

if (

  !document.documentElement.hasAttribute(

    'data-dan-quick-swipe-ready'

  )

) {

  document.documentElement.setAttribute(

    'data-dan-quick-swipe-ready',

    'true'

  );



  let danQuickBackdropSwipe = null;



  document.addEventListener(

    'touchstart',

    (event) => {

      danQuickBackdropSwipe = null;



      if (

        !window.matchMedia(

          '(max-width: 749px)'

        ).matches ||

        event.touches.length !== 1

      ) {

        return;

      }



      const dialogComponent =

        document.getElementById(

          'quick-add-dialog'

        );



      if (

        !(dialogComponent instanceof QuickAddDialog)

      ) {

        return;

      }



      const dialog =

        dialogComponent.refs?.dialog;



      if (

        !(dialog instanceof HTMLDialogElement) ||

        !dialog.open

      ) {

        return;

      }



      const touch = event.touches[0];

      const dialogRect =

        dialog.getBoundingClientRect();



      const startedOutsideDialog =

        touch.clientX < dialogRect.left ||

        touch.clientX > dialogRect.right ||

        touch.clientY < dialogRect.top ||

        touch.clientY > dialogRect.bottom;



      if (!startedOutsideDialog) return;



      danQuickBackdropSwipe = {

        x: touch.clientX,

        y: touch.clientY,

        dialog: dialogComponent,

      };

    },

    {

      passive: true,

    }

  );



  document.addEventListener(

    'touchend',

    (event) => {

      const start = danQuickBackdropSwipe;

      danQuickBackdropSwipe = null;



      if (

        !start ||

        event.changedTouches.length === 0

      ) {

        return;

      }



      const touch = event.changedTouches[0];



      const distanceX =

        touch.clientX - start.x;



      const distanceY =

        touch.clientY - start.y;



      const isDownwardSwipe =

        distanceY >= 50 &&

        Math.abs(distanceY) >

          Math.abs(distanceX) * 1.2;



      if (isDownwardSwipe) {

        start.dialog.closeDialog();

      }

    },

    {

      passive: true,

    }

  );



  document.addEventListener(

    'touchcancel',

    () => {

      danQuickBackdropSwipe = null;

    },

    {

      passive: true,

    }

  );

}
